// extracted by mini-css-extract-plugin
export default {"strip":"reNEYI","root":"TLkfx5","logo":"TaSIVv","title":"p8_WLl","subTitle":"ETenOO","returnTerm":"AyduzO","noPremiumBanner":"SFc1wP","premiumBanner":"t1ZNwd","icon":"incaD_"};